<template lang="pug">
  div.waste-generators.legal-entity-update
    router-view(
    :parentItem="fields"
    ).modal-to-front

    e-form-modal(
    ref="modalForm"
    @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
        :hideDeleteButton="(fields.id ? true : false)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="[{tab1: 'Общие сведения'},{bills: 'Лицевые счета'}]"
        )
      slot
        e-form(:formValidator="formValidator")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-show="tabView == 'tab1'")
            input(type="hidden" v-model="fields.parent_id")
            div.body
              div.col
                e-form-subtitle(text="Реквизиты")

                e-form-group(
                name="full_name"
                inputType="input"
                label="Полное наименование"
                  :model="fields"
                :required="true"
                tabView="tab1"
                )
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Сокращенное наименование"
                  :model="fields"
                  tabView="tab1"
                :required="true"
                )
                e-form-group(
                name="inn"
                inputType="input"
                label="ИНН"
                  :model="fields"
                tabView="tab1"
                  :required="true"
                )
                e-form-group(
                name="kpp"
                inputType="input"
                label="КПП"
                :model="fields"
                tabView="tab1"
                )

                e-form-group(
                name="ogrn"
                inputType="input"
                label="ОГРН/ОГРНИП потребителя"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="nza"
                inputType="input"
                label="НЗА потребителя"
                :model="fields"
                tabView="tab1"
                )

                e-form-group(
                name="address"
                inputType="address"
                label="Юридический адрес"
                :model="fields"
                tabView="tab1"
                :required="true"
                :addressData="addressData"
                )

                e-form-group(
                name="mail_address"
                inputType="address"
                label="Почтовый адрес"
                :model="fields"
                tabView="tab1"
                :required="true"
                :addressData="addressData"
                addressIdFieldName="address_mail_id"
                :treeAttributes="POST_TREE_ATTRIBUTES"
                )

              div.col
                e-form-subtitle(text="Руководитель")
                e-form-group(
                name="position"
                inputType="input"
                label="Должность"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="director_name"
                inputType="input"
                label="ФИО"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="phone"
                inputType="input"
                validationRule="phone"
                label="Телефон"
                  :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="email"
                inputType="input"
                validationRule="email"
                label="Email"
                  :model="fields"
                tabView="tab1"
                )


              div.col

          // лицевые счета
          div(v-show="tabView == 'bills'")
            garbage-bank-books(
            :fields="fields"
            ref="garbageBankBooksTable"
            tabView="bills"
            type="BANK_ACCOUNT_TYPE_LEGAL"
            )


</template>

<script>
  import {wasteGenerators} from '../../api/api-endpoints.js'
  import wasteGeneratorsForm from './mixins/waste-generators-form'
  import GarbageBankBooks from "./components/garbage-bank-books"
  import {TreeAttributes} from "../../components/address/address-tree"

  export default {
    components: {GarbageBankBooks},
    mixins: [wasteGeneratorsForm],
    data () {
      return {
        tabView: 'tab1',
        fields: {
          mail_address: '',
          address: ''
        },
        errors: null
      }
    },
    computed: {
      POST_TREE_ATTRIBUTES () {
        return new TreeAttributes('post_')
      }
    },
    methods: {
      getBankBookCreateUrl () {
        return wasteGenerators.bankBookLegalCreate(this.fields.id)
      },
      getDeleteUrl (id) {
        return wasteGenerators.legalDelete(id)
      },
      getUpdateOrCreateUrl () {
        return wasteGenerators.legalUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return wasteGenerators.legal(route.params.id)
      }
    }
  }
</script>
